import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Renderer.TrackLine = function() {
  WRAP.Renderer.GeoJSONExt.call(this);
  this._canvas = document.createElement('canvas');
  this._ctx = this._canvas.getContext('2d');

  function addFeature(layer, feature, geo, data) {
    feature.geo = geo;
    feature.data = data;
    layer.addFeature(feature);
  }

  const superDraw = this.draw;
  this.draw = function(layer, content, conf, context, style, data, revision, dl) {
    superDraw.apply(this, arguments);
  }

  this.drawFeature = function(layer, geo, prop, style, data) {
    var geometry = geo.geometry;
    if ( !geometry ) return;

    var geodesic = (style.geodesic === undefined || style.geodesic === true);
    var method = style.line_method;

    var points = geometry.coordinates;
    if ( points ) {

      const startAlt = prop.alt_ft[0];
      const endAlt = prop.alt_ft[1];

      const gradationSetting = style.gradation;
      let startIdx, endIdx;
      gradationSetting.forEach((g, idx) => {
        if (startAlt <= g.alt) startIdx = idx;
        if (endAlt <= g.alt) endIdx = idx;
      });
      let minAltIdx = endIdx;
      let maxAltIdx = startIdx;
      if (maxAltIdx < minAltIdx) {
        minAltIdx = startIdx;
        maxAltIdx = endIdx;
      }
      let isDown = false;
      let minAlt = startAlt;
      let maxAlt = endAlt;
      if (maxAlt < minAlt) {
        isDown = true;
        minAlt = endAlt;
        maxAlt = startAlt;
      }

      const range = maxAlt - minAlt;
      const list = [];
      for (let i = minAltIdx; i <= maxAltIdx; i++) {
        const currentSetting = gradationSetting[i];
        if (i === maxAltIdx && minAlt < currentSetting.alt) {
          list.push({ratio: isDown ? 1 : 0, color: currentSetting.color});
        }
        const alt = maxAlt < currentSetting.alt ? maxAlt : currentSetting.alt;
        let ratio = 0;
        if (range !== 0) {
          ratio = Math.abs((alt - minAlt) / range);
          if (isDown) {
            ratio = 1 - ratio;
          }
        }
        list.push({ratio: ratio, color: currentSetting.color});
      }
      list.sort((a, b) => {return a.ratio- b.ratio});

      var feature = new WRAP.Geo.Feature.GeoLine({
          path: points,
          lineWidth: style.line_width,
          strokeStyle: {type: 'gradation', opt: list},
          option: style.option,
          geodesic: geodesic,
          method: method
      });
      addFeature(layer, feature, geo, data ? prop : undefined);
    }
  }
};
/* eslint-enable */
